export class FetchError extends Error {
  response: Response
  data: {
    message: string
    error?: string
  }

  constructor({
    message,
    response,
    data
  }: {
    message: string
    response: Response
    data: {
      message: string
      error?: string
    }
  }) {
    // Pass remaining arguments to parent constructor
    super(message)

    // Maintains proper stack trace for where our error was thrown
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError)
    }

    this.name = 'FetchError'
    this.response = response
    this.data = data ?? { message }
  }
}

export default async function fetchJson<JSON = unknown>(
  input: RequestInfo,
  init?: RequestInit
): Promise<JSON> {
  const response = await fetch(input, init)

  // todo: add checking that content is json like in useGenericRequest
  // if the server replies, there's always some data in json
  // if there's a network error, it will throw at the previous line
  const data = await response.json()

  if (response.ok) {
    return data
  }

  throw new FetchError({
    message: response.statusText,
    response,
    data
  })
}
